import { render, staticRenderFns } from "./LotInfo.vue?vue&type=template&id=673ff97c&scoped=true"
import script from "./LotInfo.vue?vue&type=script&lang=js"
export * from "./LotInfo.vue?vue&type=script&lang=js"
import style0 from "./LotInfo.vue?vue&type=style&index=0&id=673ff97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ff97c",
  null
  
)

export default component.exports